import React from 'react';
import moment from 'moment';
import styles from './ProjectRow.module.scss';
import { IconButton, Tag, Button, WarningMessage } from 'components';
import { icons, sizes } from 'assets';
import { inject } from 'mobx-react';
import { ROUTING_STORE } from 'store';
import { RouterStore } from 'mobx-react-router';
import StatusHandler from './StatusHandler';
import { areSubProjectsPossible } from 'utilities';

interface Props {
  subprojectLevel?: number;
  project: any;
  // id: string;
  // name: string;
  // addedAt: Date;
  // tags: string[];
  // views: number;
  expandable: boolean;
  expanded: boolean;
  onClick: () => void;
  [ROUTING_STORE]?: RouterStore;
  flatTable?: boolean;
  removeLine?: () => void;
}

const ProjectRow = (props: Props) => {
  const {
    subprojectLevel = 0,
    project,
    expandable, expanded, onClick,
    [ROUTING_STORE]: { push },
    flatTable,
    removeLine
  } = props;

  const handleOnTitleClick = () => {
    if (flatTable) return;

    expandable
      ? onClick()
      : push(`/projects/edit/${project.id}`);
  };

  const additionalPadding = expandable ? 0 : 33;

  const tableRowStyles = [styles.tableRow];
  flatTable && tableRowStyles.push(styles.flatTableRow);

  return (
    <div
      className={tableRowStyles.join(' ')}
      style={{ backgroundColor: `rgb(180,180,180,0.${subprojectLevel})` }}
    >
      <h4
        style={{ paddingLeft: flatTable ? 0 : subprojectLevel * 30 + additionalPadding }}
        onClick={handleOnTitleClick}
      >
        {expandable &&
          <IconButton
            icon={expanded ? icons.minus : icons.plus}
            onClick={onClick}
          />
        }
        <span className={styles.projectTitle}>{project.name}</span>

        <WarningMessage
          object={project}
          objectType='project'
        />

      </h4>

      <div style={{ width: sizes.projectsTableTypeWidth }}>
        {project.type}
      </div>

      <div style={{ width: sizes.projectsTableAddedAtWidth }}>
        {moment(project.createdDate).format('HH:mm, DD.MM.YYYY')}
      </div>

      {/* <div style={{ width: sizes.projectsTableViewsWidth }}>
        {project.views}
      </div> */}

      <div style={{ width: sizes.projectsTableTagsWidth }}>
        {project.tags && project.tags.split(',').map((tag, index) =>
          <Tag key={index} tag={tag} />
        )}
      </div>

      <div style={{ width: sizes.projectsTableGenreWidth }}>
        {project.genres.join(', ')}
      </div>

      <StatusHandler project={project} flatTable={flatTable} />

      <div className={styles.buttonsContainer}>
        {!flatTable &&
          <>
            {project.readyForEdit &&
              <IconButton
                icon={icons.magicStick}
                title='Open in editor'
                className={styles.optionButton}
                onClick={() => push(`/editor/${project.id}`)}
              />
            }

            <IconButton
              icon={icons.addFolder}
              title='Add a sub project'
              className={styles.optionButton}
              onClick={() => push(`/projects/create/${project.id}`, { parentProject: project })}
              disabled={!areSubProjectsPossible(project.type)}
            />
            <IconButton
              icon={icons.pen}
              title='Edit project'
              className={styles.optionButton}
              onClick={() => push(`/projects/edit/${project.id}`)}
            />
          </>
        }
        {flatTable &&
          <Button
            type='cancel'
            size='small'
            onClick={removeLine}
            className={styles.deleteButton}
          >
            delete
          </Button>

        }
      </div>
    </div>
  );
};

export default inject(ROUTING_STORE)(ProjectRow);